import api from '../../store/config/api';
import { FILTER as SCHEMA } from '../../schemas';

export const [
  GET_FILTERS,
  GET_FILTERS_REQUEST,
  GET_FILTERS_SUCCESS,
  GET_FILTERS_FAILURE
] = api.buildTypes('GET_FILTERS');

export function getFilters({ teamName, username = 'me' }) {
  return {
    type: GET_FILTERS,
    payload: {
      url: `/teams/${teamName}/users/${username}/filters`,
      schema: { filters: [SCHEMA] },
      options: {
        method: 'GET'
      }
    }
  };
}

export const [
  ADD_FILTER,
  ADD_FILTER_REQUEST,
  ADD_FILTER_SUCCESS,
  ADD_FILTER_FAILURE
] = api.buildTypes('ADD_FILTER');

export function addFilter({ teamName, filterData, username = 'me' }) {
  return {
    type: ADD_FILTER,
    payload: {
      url: `/teams/${teamName}/users/${username}/filters`,
      schema: SCHEMA,
      options: {
        method: 'POST',
        body: filterData
      }
    }
  };
}

export const [
  DELETE_FILTER,
  DELETE_FILTER_REQUEST,
  DELETE_FILTER_SUCCESS,
  DELETE_FILTER_FAILURE
] = api.buildTypes('DELETE_FILTER');

export function deleteFilter({ teamName, filterID, username = 'me' }) {
  return {
    type: DELETE_FILTER,
    paylod: {
      url: `/teams/${teamName}/users/${username}/filters/${filterID}`,
      schema: SCHEMA,
      options: {
        method: 'DELETE'
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/filter.js